/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { FormField } from "Abstracts/wec-e-form-field/wec-e-form-field";
import { render, TemplateResult } from "lit-html";
import { uiElement, uiEvent } from "@kluntje/core";

import { TextInputTemplateArgs } from "./wec-e-text-input.template";

export class VicTextInput extends FormField<string> {
  textInputTemplate?: (args: TextInputTemplateArgs) => TemplateResult;
  @uiElement(".wec-js-form-field__input")
  input: HTMLInputElement;

  get minlength(): number | undefined {
    const curMinlength = this.getAttribute("minlength");
    if (curMinlength === null) return undefined;
    return parseInt(curMinlength, 10);
  }

  get maxlength(): number | undefined {
    const curMaxlength = this.getAttribute("maxlength");
    if (curMaxlength === null) return undefined;
    return parseInt(curMaxlength, 10);
  }

  get valuePattern(): string | undefined {
    return this.getAttribute("pattern") || undefined;
  }

  get initialValue(): string {
    return this.getAttribute("initial-value") || "";
  }

  /**
   * Returns needed Args for rendering
   * @returns {TextInputTemplateArgs}
   */
  get renderArgs(): TextInputTemplateArgs {
    return {
      component: this,
    };
  }

  afterComponentRender() {
    if (this.initialValue !== "") {
      this.ui.input.value = this.initialValue;
      this.renderComponent();
    }
    super.afterComponentRender();
  }

  get currentValue(): string {
    return this.ui.input.value || "";
  }

  async renderAsync() {
    try {
      this.textInputTemplate = await this.loadTemplate();
      this.renderComponent();
    } catch (e) {
      console.error("CheckGroup:", e);
    }
  }

  async loadTemplate(): Promise<(args: TextInputTemplateArgs) => TemplateResult> {
    const { textInputTemplate } = await import("./wec-e-text-input.template");
    return textInputTemplate;
  }

  @uiEvent<VicTextInput>("input", "keyup")
  handleKeyup() {
    this.hasExternalError = false;
    this.renderComponent();
  }

  renderComponent() {
    if (this.textInputTemplate === undefined) return;

    if (this.state.inValidationMode) this.validate();
    render(this.textInputTemplate(this.renderArgs), this.getUiRoot());
  }

  onFocus(e: FocusEvent) {
    // to fix inheritance bug with kluntje decorators
    // @TODO: Remove later
  }

  onFocusOut(e: FocusEvent) {
    // to fix inheritance bug with kluntje decorators
    // @TODO: Remove later
  }

  clearInput() {
    this.ui.input.value = "";
    this.renderComponent();
  }
}

customElements.define("wec-e-text-input", VicTextInput);
